// VENDOR LIBRARIES
const jquery = require('jquery');
$ = window.$ = window.jQuery = jquery;

import {
	gsap
} from "gsap";
const lottie = require('lottie-web');

import {
	ScrollScene,
	addIndicators,
	jQuery
} from 'scrollscene';

// JQ PLUGINS
const svg4everybody = require('svg4everybody');
const owlCarousel = require('./vendor/owl.carousel');
const overlayScrollbars = require('./vendor/jquery.overlayScrollbars.min');
const ScrollBooster = require('./vendor/scrollbooster.min');

// LOTTIE ANIMATIONS
const aniStopWatchRed = require('../media/animations/stopwatch_red');
const aniStopWatchYellow = require('../media/animations/stopwatch_yellow');



// console.log(gsap);
// APP
window.app = {
	eventDate: 'october 15, 2021 12:30:00', // Date to count down till
	// eventDate: 'feb 27, 2020 10:58:00',
	covidMsgTill: 'january 1, 2021 01:0:00', // date to display Covid19 Msg until
	guests: { // Guest list api settings
		apiPath: 'https://cms.podgeevents.com/api2/get-members/key/16y7seync7dd4ljs691mhr7tpo9t53yisznreea',
		// photoPath: 'https://cms.podgeevents.com/api/getphoto/key/wlzkl4nyvxem7rviw67yu0sw84fq9mpzvwf2ixv0/dir/150/photo/',
		// ALL ELSE FAILED!
		photoPath: 'http://cms.podgeevents.com/api/getphoto/key/wlzkl4nyvxem7rviw67yu0sw84fq9mpzvwf2ixv0/dir/150/photo/',
		data: null,
		list: '',
		ready: false,
	},
	counters: {}, // store counters
	counterSpeed: 4, // seconds
	sliders: {}, // store sliders
	menuOpen: false, // track menu open

	/////////////////////////////////////////
	// APP.INIT()
	/////////////////////////////////////////
	init: () => {
		//console.info('app.init()=>');

		let covidDate = new Date(app.covidMsgTill);
		let today = new Date();

		// check for Covid 19 msg
		if (covidDate > today) {
			// show Covid Msg
			$('#headCovid').css('display', 'block');
		} else {
			// Show Countdown
			$('#headCounter').css('display', 'block');
			app.countDown('#js-eventCountDown', app.eventDate);
		}

		// Start count ups
		app.countupSetup('.sect.sect-feature');

		// Get the Guest list
		app.guestGet(app.guests.apiPath, () => {
			// Build the guest list DOM
			app.guestBuild($('#js-guestList'), app.guestData,
				null, () => {

					app.guestSearch()
				});
		});

		// Setup Supporters slider
		app.sliderMake($('#js-supporterSlider'), aniStopWatchYellow, {
			loop: true,
			responsiveClass: true,
			dotsEach: 1,
			nav: true,
			navClass: ["btn-owl btn-owl--prev", "btn-owl btn-owl--next"],
			responsive: {
				0: {
					items: 1,
					dots: false,

					margin: 20,
				},
				768: {
					items: 2,
					dots: true,
					margin: 20,
				},
				1024: {
					items: 3,
					margin: 40,
				}
			}
		});

		// Setup Testimonial Slider
		app.sliderMake($('#js-testimonalSlider'), aniStopWatchRed, {
			loop: true,
			responsiveClass: true,
			dotsEach: 1,
			nav: true,
			navClass: ["btn-owl btn-owl--prev", "btn-owl btn-owl--next"],
			responsive: {
				0: {
					items: 1,
					dots: false,

					margin: 20,
				},
				768: {
					items: 2,
					dots: true,
					margin: 20,
				},
				1024: {
					items: 3,
					margin: 40,
				}
			}
		});

		// SCROLL MAGIC

		app.scrollMagicStart();

		// Start DomEvent listeners
		app.bindDomEvents();
	},

	/////////////////////////////////////////
	// BIND EVENTS
	/////////////////////////////////////////
	bindDomEvents: () => {

		// Smooth Scroll anchor links
		$('a[href^="#"]').click((e) => {
			e.preventDefault();
			//console.log(e);
			app.smoothScroll($(e.currentTarget).attr('href'));
		});

		// Menu Toggle
		$('#js-menuTogg').click(() => {
			app.menuToggle();
		});

		// SLide rvbutton Animations
		// app.sliderAniBtn("btn-owl");
	},

	onWindowResize: () => {
		let width = $(window).width();
		let height = $(window).height();

		app.menuToggle(false);

		$('.js-guestSearch').val('');
		app.guests.list.search('');
		app.guestMatchHeight();



	},

	onWindowScroll: () => {

		// Get Scroll Data
		let wH = $(window).height(); // window height
		var wT = $(window).scrollTop(); // Window top scroll pos
		var wC = wT + (wH / 2); // Window central scroll poss
		var wB = wT + wH; // Window bottom scroll pos

		// Check feature sections to trigger countUps
		$('.sect.sect-feature').each((i, el) => {
			app.countupCheck($(el), wH, wT, wC, wB);
		});

	},

	//////////////////////////////////////////////
	// UI FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	// Open Close Mobile Menu
	//::::::::::::::::::::::::::::::::::::::::::::
	menuToggle: (open) => {

		if ((open == true && app.menuOpen == false) || (open === undefined && app.menuOpen == false)) {

			$('#js-mobMenu').addClass('is-open');
			$('#js-menuTogg').addClass('is-open');
			app.menuOpen = true;


		} else if ((open == false && app.menuOpen == true) || (open === undefined && app.menuOpen == true)) {

			$('#js-mobMenu').removeClass('is-open');
			$('#js-menuTogg').removeClass('is-open');
			app.menuOpen = false;

		}

		//console.log(app.menuOpen)
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Animated anchor link scrolling
	//::::::::::::::::::::::::::::::::::::::::::::
	smoothScroll: (id) => {

		if ($(id).length == 0) return; // if no matching DOM element found

		// Offset for navbar heaight
		let navBar = 0;
		if (Detectizr.device.type != 'desktop') {
			navBar = $('.navbar').outerHeight();
		}

		var targetPos = $(id).offset().top - navBar; // get new offset
		if ($(id).offset().top == 0) {
			history.pushState(null, null, '#'); // clear window hash for Top
		} else {
			history.pushState(null, null, id); // update window hash
		}
		let delay = 0;

		if (app.menuOpen == true) {
			app.menuToggle(false);
			delay = 500;
		}

		setTimeout(() => {
			$('html, body').animate({
				scrollTop: targetPos // scroll to offset
			}, 600);
		}, delay);

	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Animated buttons for sliders
	//::::::::::::::::::::::::::::::::::::::::::::
	timerIcon: (el, ani) => {
		// console.log($el[0]);

		let myani;

		let $el = $(el);

		// Desktop
		if (Detectizr.device.type == 'desktop') {

			myani = lottie.loadAnimation({
				container: el, // the dom element that will contain the animation
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: ani // the path to the animation json
			});

			$el.hover(() => {
				myani.setSpeed(1);
				myani.play();
			}, () => {
				myani.setSpeed(-1);
				myani.play();
			});

			// Touch devices
		} else {

			myani = lottie.loadAnimation({
				container: el, // the dom element that will contain the animation
				renderer: 'svg',
				loop: false,
				autoplay: false,
				path: ani // the path to the animation json
			});

			$el.click(() => {
				myani.setSpeed(1);
				myani.play();
				myani.addEventListener('complete', () => {

					myani.setSpeed(-1);
					myani.play();

				});
			});
		}
	},

	//////////////////////////////////////////////
	// COUNT DOWN FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Start a countdown timer
	//::::::::::::::::::::::::::::::::::::::::::::
	countDown: (id, date) => {


		const target = new Date(date).getTime();

		// Converts numbers to strings and add preceeding 0 for < 10
		const convertDuobleDigits = (num) => {
			if (num < 10) {
				num = "0" + num;
			} else {
				num = "" + num;
			}

			return num;
		};

		let isTripleDigit = false; // track if days are 000 digits

		// converts 00 days to 000 days
		const tripleDigDays = () => {
			isTripleDigit = true; // prevent repeat
			$(id).addClass('is-tripDays');
			$(id).closest('.eventCount').addClass('is-tripDays');
			$(id).prepend('<div class="counter__digit is-tripDay">0</div>');

		};

		// Converts 000 days back to 00 days
		const doubleDigDays = () => {
			isTripleDigit = false;
			$(id).removeClass('is-tripDays');
			$(id).closest('.eventCount').removeClass('is-tripDays');
			const $tripDay = $(id).find('.is-tripDay');
			$tripDay.remove();
		};

		// Converts countdown values to array
		const countdownToArray = (day, hour, min, sec) => {

			if (day >= 100 && isTripleDigit == false) tripleDigDays(); // Modify for triple digit days
			if (day == 99 && isTripleDigit == true) doubleDigDays(); // un-Modify for double digit days

			const dd = convertDuobleDigits(day);
			const hh = convertDuobleDigits(hour);
			const mm = convertDuobleDigits(min);
			const ss = convertDuobleDigits(sec);
			const date = dd + hh + mm + ss;

			return date;
		};

		// updates timer every 1sec
		const ticker = setInterval(() => {

			const now = new Date().getTime();
			const timeTill = target - now;
			const day = Math.floor(timeTill / (1000 * 60 * 60 * 24));
			const hour = Math.floor((timeTill % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
			const min = Math.floor((timeTill % (1000 * 60 * 60)) / (1000 * 60));
			const sec = Math.floor((timeTill % (1000 * 60)) / 1000);

			const countDown = countdownToArray(day, hour, min, sec)

			// COUNTDONW ENDED
			if (timeTill <= 0) {
				$(id).addClass('is-ended');
				app.updateCountDown(id, [0, 0, 0, 0, 0, 0, 0, 0])
				clearInterval(ticker);
				return;
			};

			app.updateCountDown($(id), countDown)
		}, 1000);
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Update a counter
	//::::::::::::::::::::::::::::::::::::::::::::
	updateCountDown: ($counter, digits) => {

		digits = digits.split(''); // convert digits string to an array

		$counter.find('div').each((index, el) => {
			$(el).html(digits[index]);
		});

	},

	//////////////////////////////////////////////
	// COUNTUP FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! SETUP ALL THE COUNTUPS
	//::::::::::::::::::::::::::::::::::::::::::::
	countupSetup: (els) => {
		const $els = $(els);

		$els.each((i, el) => {
			const $el = $(el);
			const name = $el.attr('data-countname');
			const num = $el.attr('data-countup');

			app.counters[name] = {
				'name': name,
				'count': num,
				'isEmpty': true,
				'tickers': [],
				'$el': $(el),
				'$counter': $(el).find('.counter'),
				'length': num.length
			}

		});
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Check to see if a count up can be started
	//::::::::::::::::::::::::::::::::::::::::::::
	countupCheck: ($el, wH, wT, wC, wB) => {

		const counter = app.counters[$el.attr('data-countname')];

		const elT = $el.offset().top;
		const elB = elT + $el.outerHeight();

		// RESET CONDITION
		//if ((elB < wT - (wH / 2)) || (elT > wB + (wH / 2))) {
		// 	return; // exit
		// }


		// START CONDITION
		if ((elB > wT + (wH / 2)) && (elT < wB - (wH / 2))) {
			if (!counter.ticker) app.countupStart($el, counter)
		}
	},


	//::::::::::::::::::::::::::::::::::::::::::::
	//! START COUNTUP
	//::::::::::::::::::::::::::::::::::::::::::::
	countupStart: ($el, counter) => {

		const $digits = $el.find('.counter__digit:not(.is-empty)');
		// console.log(counter);

		// console.log('IN')
		if (!counter.isEmpty) return;

		const targets = counter.count.split(''); // change count to an array

		counter.isEmpty = false;



		$digits.each((i, el) => {

			const $digit = $(el);
			const target = targets[i]; // change count to an array
			// Count tracker
			app.countupAni($digit, target);

		})

	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Animation for each digit of the count
	//::::::::::::::::::::::::::::::::::::::::::::
	countupAni: ($digit, target) => {

		let theCount = {
			i: 0
		};
		let currentCount = theCount.i; // save count before update(s) for comparison

		const ani = gsap.to(theCount, app.counterSpeed, {
			i: target,
			roundProps: "i",
			ease: "power4.out",
			onUpdate: () => {
				// console.log(theCount.i);
				if (currentCount != theCount.i) {

					$digit.html(theCount.i);
				}
			},
			onComplete: () => {
				// console.log('OVER');
			}
		});
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! ADD PRECCEDING 0's to countup value
	//::::::::::::::::::::::::::::::::::::::::::::
	countupFormat: (num, length) => {

		let n = num + "";
		while (n.length < 5) n = "0" + n;
		return n;

	},

	//////////////////////////////////////////////
	// GUEST DATA
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Get Guest Data from API
	//::::::::::::::::::::::::::::::::::::::::::::
	guestGet: (apiPath, callback) => {

		app.dataGet(apiPath, function (data) {

			app.guestData = data; // store the data

			if (callback) callback();

		}); // Return data to app
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Build HTML for Guest List
	//::::::::::::::::::::::::::::::::::::::::::::
	guestBuild: ($el, data, callWith, callAfter) => {

		let guestList = [];
		let gGroup = '';
		let guestImages = [];
		let iGroup = [];
		const gPerGroup = 20;
		let gGroupI = 1;

		// Loop each guest.
		$.each(data, (index, item) => {
			// Get this item
			// console.log(item);
			// Add copy to designated child
			let guest = {
				name: item.firstName + ' ' + item.lastName,
				job: item.job,
				company: item.company,
				img: app.guests.photoPath + item.photo
			};

			let htmlImg = "";

			if (item.photo) {
				htmlImg = `<img src="${guest.img}" alt="" />`;
			}

			const html = `
				<li id="guest-${index}" class="js-guestItem guestList__item" >
					<div class="guest">
						<div class="guest__image">
							<div class="guestImage" >
								${htmlImg}
							</div>
						</div>
						<div class="guest__data">
							<h4 class="list-name">${guest.name}</h4>
							<p class="data-job">${guest.job}</p>
							<p class="list-company">${guest.company}</p>
						</div>
					</div>
				</li>
			`;

			// GROUP GUESTS INTO SETS OF 18 FOR GRADUAL LOADING
			gGroup = gGroup + html; // add Guest to group
			iGroup.push('#guest-' + index + ' img'); // store image with group

			let grpCount = gPerGroup * gGroupI;

			if (index == (grpCount - 1) || index == data.length - 1) { // if last guest in group...
				guestList.push(gGroup) // add the group to master list
				guestImages.push(iGroup); // add image group to image list
				gGroup = ''; // reset the group array
				gGroupI++; // Advnace the current group index
			}

		});

		// console.log(guestList);

		// LOOP THE GUEST LIST..
		let grpI = 0;
		let listlen = guestList.length;

		// Stagger loop to avoid image loading issue
		let guestLoop = setInterval(() => {

			//console.log(guestList[grpI]);

			// CH£CK GROUP EXISTS
			if (grpI < listlen) {


				// console.log(grpI)
				$el.append(guestList[grpI]); // add the thml to dom
				app.guestMatchHeight(); // (re)check height

				let images = guestImages[grpI]; // get the images for this group

				// CHECK IMAGES FOR LAOD ERRORS
				$.each(images, (i, img) => {

					$(img).on('load', function () {
						$(img).css('opacity', 1);
					});

					$(img).on('error', (e) => {

						$(img).css('opacity', 0);
						console.error("error loading image: " + img);
						console.log(e);
					});
				})

				// DO ON FIRST LOOP
				if (grpI === 0 && callWith) callWith();

				grpI++; // NEXT GROUP

				if (!app.sb) {
					app.guestScroll();
				} else {

					// let scrollerPos = app.sb.getUpdate().position;
					// console.log(scrollerPos.x);
					app.sb.updateMetrics();
					// console.log(scrollerPos.x);
					// app.sb.scrollTo(scrollerPos.x, scrollerPos.y);
				}

				// FINISHED!
			} else {
				callAfter(); // do callback
				clearInterval(guestLoop); // stop the loop
			}


		}, 2000);

	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Fetch remote Data Source
	//::::::::::::::::::::::::::::::::::::::::::::
	dataGet: (path, callback) => {

		$.when($.ajax({
				url: path,
				type: 'GET',
				crossDomain: true,
				// dataType:'json',
			}).done(function (data) {
				// _data = data;
			}).fail(function () {
				console.error('Error from API - Please Try Again Later');
				//setTimeout
				return "Sorry we seem to be encountering an error. Please try again";

			}).always(function () {
				//console.log('complete');
			}))
			// on AJAX finish
			.then(function (data) {
				// console.log(data);
				callback(app.dataSanitize(data));

			});
	},
	//::::::::::::::::::::::::::::::::::::::::::::
	//! Clean the data up
	//::::::::::::::::::::::::::::::::::::::::::::
	dataSanitize: (data) => {
		//console.log(data);
		var regex = new RegExp(/<!\[CDATA\[(.*)]]>/); // use to sanitize xml

		var members = []; // temorary store data here

		for (var i = 0; i < data.getElementsByTagName("First_Name").length; i++) {

			var object = {};
			object.id = i;
			object.firstName = data.getElementsByTagName("First_Name")[i].childNodes[0].textContent;
			object.lastName = data.getElementsByTagName("Last_Name")[i].childNodes[0].textContent;
			// object.twitter = data.getElementsByTagName("Twitter")[i].childNodes[0].textContent;
			// object.email = data.getElementsByTagName("Email")[i].childNodes[0].textContent;
			object.job = data.getElementsByTagName("Job_Title")[i].childNodes[0].textContent;
			object.company = data.getElementsByTagName("Company_Name")[i].childNodes[0].textContent;
			object.photo = data.getElementsByTagName("Photo")[i].childNodes[0].textContent;
			// object.status = data.getElementsByTagName("Status")[i].childNodes[0].textContent;
			// console.log(object);
			members.push(object);
		};
		// console.log(members)
		return members;
	},

	//////////////////////////////////////////////
	//! Guest Scrolling
	//////////////////////////////////////////////
	guestMatchHeight: () => {


		// reset to auto or else we can't check height
		$('.js-guestItem').css({
			'height': 'auto'
		});

		$('#js-guestList').css({
			'height': 'auto'
		})

		let itemHeight = 0;

		// get highest value
		$('.js-guestItem').each(function (i, obj) {
			itemHeight = Math.max(itemHeight, $(obj).outerHeight())
		});

		// set the height
		$('.js-guestItem').css({
			'height': itemHeight + 'px'
		});

		let windowWidth = $(window).width();

		let listHeight = itemHeight * 2;

		if (windowWidth >= 768) {

			listHeight = itemHeight * 2;

			if (windowWidth >= 992) {
				listHeight = itemHeight * 3;
			}
		}

		listHeight = listHeight + 20;

		$('#js-guestList').css({
			'height': listHeight + 'px'
		});

		// match width of
		if (windowWidth < 768) {
			$('#js-guestSearch .searchField').css('width', '100%');
		} else {
			let width = $('.js-guestItem:first-child .guest').innerWidth();
			$('#js-guestSearch .searchField').css('width', width);
		}

	},


	guestScroll: function () {

		//Custom Scroll Bars
		$('#js-guestScroll').overlayScrollbars({
			className: null,
		});

		// Drag scrolling
		var viewport = document.querySelector('#js-guestScroll .os-viewport');
		var content = viewport.querySelector('#js-guestScroll .os-content');

		app.sb = new ScrollBooster({
			viewport: viewport,
			content: content,
			mode: 'x',
			onUpdate: function (data) {
				viewport.scrollLeft = data.position.x;



			}
		});

		app.scrollMagicColorChange($('#Guests'), '#695CFF', '#1F1F1F', '50%', 0.25, 0, false);
	},

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Guest Search
	//::::::::::::::::::::::::::::::::::::::::::::
	guestSearch: () => {

		app.guests.list = new List('Guests', {
			valueNames: ['list-name', 'list-company'],
			listClass: 'js-theguestlist',
			searchClass: "js-guestSearch",
			// fuzzySearch: {
			//     searchClass: "js-guestSearch",
			//     location: 0,
			//     distance: 10,
			//     threshold: 0.4,
			//     multiSearch: false
			// }
		});

		$('#js-guestSearch').addClass('is-ready');

		// console.log(app.guests.list);
	},

	//////////////////////////////////////////////
	// SLIDER FUNCTIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Make Slider and track it (app.slider[name])
	//::::::::::::::::::::::::::::::::::::::::::::
	sliderMake: ($el, ani, settings) => {
		let id = $el.attr('id');
		app.sliders[id] = $el.owlCarousel(settings);

		if (ani) app.sliderAniBtn(id, ani)

	},

	sliderAniBtn: (id, ani) => {
		let btns = document.querySelectorAll('#' + id + ' .btn-owl');
		for (var i = 0; i < btns.length; i++) {

			app.timerIcon(btns.item(i), ani);
		}
	},

	//////////////////////////////////////////////
	// SCROLL MAGIC ANIMATIONS
	//////////////////////////////////////////////

	//::::::::::::::::::::::::::::::::::::::::::::
	//! Name
	//::::::::::::::::::::::::::::::::::::::::::::
	scrollMagicStart: () => {

		if (Detectizr.device.type != 'desktop') return; // quit on devices

		const debug = false;

		app.scrollMagicGradient($('#History'), '#FF8533', '80%', 0.5, 0, debug);

		app.scrollMagicColorChange($('#Food'), '#FA334A', '#695CFF', '100%', 0.1, 0, debug);


		// MUST BE ACTIVATED AFTER GUEST SCROLL FUNCTIONALITY!
		//app.scrollMagicColorChange($('#Guests'), '#695CFF', '#1F1F1F', '50%', 0.25, 0, false);


		app.scrollMagicDot($('#Venue'), '#FA334A', '150%', 0.25, 0, debug);

		$('body').addClass('is-scrollMagic')

	},

	scrollMagicScene: ($trigger, ani, dur, hook, offset, debug) => {

		let trigger = document.querySelector('#' + $trigger.attr('id'));

		let scene = new ScrollScene({
			triggerElement: trigger,
			gsap: {
				timeline: ani,
			},
			duration: dur,
			triggerHook: hook,
			offset: offset
		});

		if (debug) {
			scene.Scene.addIndicators({
				name: '#' + $trigger.attr('id') + ': ' + debug,
				colorEnd: '#FFFFFF'
			})
		}

	},

	scrollMagicColorChange: ($el, colorFrom, colorTo, duration, hook, offset, debug) => {

		let targets = [$el];

		if ($el.find('.os-scrollbar-handle').length) {
			targets.push($el.find('.os-scrollbar-handle'))
		}

		const ani = gsap.timeline({
			paused: true
		});

		ani.fromTo(targets, 1.5, {
			backgroundColor: colorFrom,
		}, {
			backgroundColor: colorTo,
		});

		if (debug) debug = 'colorChange';
		app.scrollMagicScene($el, ani, duration, hook, offset, debug);
	},

	scrollMagicGradient: ($el, color, duration, hook, offset, debug) => {

		let html = '<div class="sm-gradient" style="color:' + color + ';"></div>';
		$el.prepend(html);

		let $gradient = $el.find('.sm-gradient');

		let fadeoffset = $gradient.css('fontSize');

		const ani = gsap.timeline({
			paused: true
		});

		ani.to($gradient, 1.5, {
			y: '0%'
		});

		if (debug) debug = 'gradient';
		app.scrollMagicScene($el, ani, duration, hook, offset, debug);

	},

	scrollMagicDot: ($el, color, duration, hook, offset, debug) => {

		let html = '<div class="sm-dot"></div>';
		$el.prepend(html);
		let $dot = $el.find('.sm-dot');

		// Move the dot
		const moveDot = (x, y) => {
			gsap.to($dot, 0.5, {
				'left': x,
				'top': y,
				ease: "power1.out"
			});
		}

		// Track mouse and set DOT position
		$el.on('mousemove', function (e) {
			// console.log(e)
			let parentOffset = $el.offset();

			moveDot(e.pageX - parentOffset.left, e.pageY - parentOffset.top)
		});

		const ani = gsap.timeline({
			paused: true
		});

		ani.to($dot, 1.5, {
			scale: '75',
			ease: "power1.ease"
		});

		if (debug) debug = 'dot';
		app.scrollMagicScene($el, ani, duration, hook, offset, debug);
	},
};

/////////////////////////////////////////
// DOC READY
/////////////////////////////////////////
$(document).ready(function () {

	// Inline SVG Symbols
	svg4everybody({
		polyfill: true // polyfill <use> elements for External Content
	});

	// START THE APP!
	app.init();

	//::::::::::::::::::::::::::::::::::::::::::::
	//! WINDOW RESIZE EVENTS
	//::::::::::::::::::::::::::::::::::::::::::::
	var rs;
	$(window).resize(function () {
		clearTimeout(rs);
		rs = setTimeout(function () {
			// DO ON WINDOW RESIZE
			app.onWindowResize();
		}, 250);
	});

	//::::::::::::::::::::::::::::::::::::::::::::
	// WINDOW SCROLL EVENT
	//::::::::::::::::::::::::::::::::::::::::::::
	$(window).on('resize scroll', function () {
		app.onWindowScroll();
	});
});

app = window.app;